import { ProFormaGenericColumn } from 'views/ProFormaTable/components/ProFormaGenericTable/types';

export const RENT_STEP_OPTIONS = [
    { value: 1, label: 'Annual' },
    { value: 2, label: 'Every 2 years' },
    { value: 3, label: 'Every 3 years' },
    { value: 4, label: 'Every 4 years' },
    { value: 5, label: 'Every 5 years' },
    { value: 6, label: 'Every 6 years' },
    { value: 7, label: 'Every 7 years' },
    { value: 8, label: 'Every 8 years' },
    { value: 9, label: 'Every 9 years' },
    { value: 10, label: 'Every 10 years' },
];

export const BASE_RENTAL_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'floor',
        field: 'floor',
        header: 'Floor',
        isFixed: true,
        type: 'number',
    },
    {
        key: 'allocationPercentage',
        field: 'allocationPercentage',
        header: 'Allocation',
        isFixed: true,
        type: 'number',
        format: 'percentage',
    },
    {
        key: 'sf',
        field: 'sf',
        header: 'SF',
        isFixed: true,
        type: 'number',
        format: 'custom',
        isReadOnly: true,
    },
    {
        key: 'valuePerSfPerYear',
        field: 'pricePerSf',
        header: '$/SF/year',
        isFixed: true,
        format: 'currency',
    },
    {
        key: 'annualRent',
        field: 'annualRent',
        header: 'Annual rent (yr 1)',
        isFixed: true,
        format: 'currency',
        allowHeaderWrap: true,
    },
];

export const BASE_RECOVERY_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'recoveryType',
        field: 'recoveryType',
        header: 'Recovery (avg. per tenant)',
        isFixed: true,
        isReadOnly: true,
    },
    {
        key: 'invisibleUnits',
        field: 'invisibleUnits',
        header: '',
        isHidden: true,
        isFixed: true,
    },
    {
        key: 'invisibleUnits',
        field: 'invisibleUnits',
        header: '',
        isHidden: true,
        isFixed: true,
    },
    {
        key: 'recoveryStart',
        field: 'recoveryStart',
        header: 'Rec. start',
        isFixed: true,
    },
    {
        key: 'recoveryPercentage',
        field: 'recoveryPercentage',
        header: 'Rec. %',
        isFixed: true,
        format: 'percentage',
    },
    {
        key: 'pricePerSf',
        field: 'pricePerSf',
        header: '$/SF/year',
        isFixed: true,
        format: 'currency',
        isReadOnly: true,
    },
    {
        key: 'invisibleUnits',
        field: 'invisibleUnits',
        header: '',
        isHidden: true,
        isFixed: true,
    },
    {
        key: 'amountYear',
        field: 'amountYear',
        header: 'Amount/year',
        isFixed: true,
        isReadOnly: true,
        format: 'currency',
    },
];

export const BASE_ACTUAL_RENTAL_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'suite',
        field: 'suite',
        header: 'Suite',
        isFixed: true,
    },
    {
        key: 'tenant',
        field: 'tenant',
        header: 'Tenant',
        isFixed: true,
    },
    {
        key: 'leaseStart',
        field: 'leaseStart',
        header: 'Lease start',
        isFixed: true,
        allowHeaderWrap: true,
    },
    {
        key: 'rentStart',
        field: 'rentStart',
        header: 'Rent start',
        isFixed: true,
        allowHeaderWrap: true,
    },
    {
        key: 'rentGrowth',
        field: 'rentGrowth',
        header: 'Rent growth',
        format: 'percentage',
        isFixed: true,
        allowHeaderWrap: true,
    },
    {
        key: 'rentStep',
        field: 'rentStep',
        header: 'Rent step',
        format: 'percentage',
        isFixed: true,
    },
    {
        key: 'squareFootage',
        field: 'squareFootage',
        header: 'RSF',
        format: 'none',
        isFixed: true,
    },
    {
        key: 'valuePerSfPerYear',
        field: 'valuePerSfPerYear',
        header: '$/RSF/year',
        format: 'currency',
        isFixed: true,
    },
    {
        key: 'annualRent',
        field: 'annualRent',
        header: 'Annual rent (yr 1)',
        format: 'currency',
        isFixed: true,
        allowHeaderWrap: true,
    },
];

export const BASE_ACTUAL_RECOVERY_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'tenant',
        field: 'tenant',
        header: 'Recovery',
        isFixed: true,
        isReadOnly: true,
    },
    {
        key: 'recoveryStart',
        field: 'recoveryStart',
        header: 'Rec. start',
        isFixed: true,
        isReadOnly: true,
    },
    {
        key: 'recoveryPercentage',
        field: 'recoveryPercentage',
        header: 'Rec. %',
        isFixed: true,
        format: 'percentage',
    },
    {
        key: 'proRataShare',
        field: 'proRataShare',
        header: 'Pro rata share',
        isFixed: true,
        isReadOnly: true,
        format: 'percentage',
    },
    {
        key: 'recoveryValuePerSfPerYear',
        field: 'recoveryValuePerSfPerYear',
        header: '$/RSF/year',
        format: 'currency',
        isFixed: true,
    },
    {
        key: 'recoveryAmountPerYear',
        field: 'recoveryAmountPerYear',
        header: 'Amount/year',
        format: 'currency',
        isFixed: true,
    },
];

export const OTHER_INCOME_BASE_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'name',
        field: 'name',
        header: 'Other income',
        format: 'none',
        type: 'text',
        isFixed: true,
    },
    {
        key: 'startDate',
        field: 'startDate',
        header: 'Start',
        isFixed: true,
    },
    {
        key: 'annualGrowth',
        field: 'annualGrowth',
        header: 'Annual growth',
        format: 'percentage',
        isFixed: true,
    },
    {
        key: 'percentOfTotalRent',
        field: 'percentOfTotalRent',
        header: '% of rental income',
        format: 'percentage',
        isFixed: true,
    },
    {
        key: 'pricePerSfPerYear',
        field: 'pricePerSfPerYear',
        header: '$/RSF/year',
        format: 'currency',
        isFixed: true,
    },
    {
        key: 'amountPerYear',
        field: 'amountPerYear',
        header: 'Amount/year',
        format: 'currency',
        isFixed: true,
    },
];

export const TOTAL_POTENTIAL_BASE_ACTUALS_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'name',
        field: 'name',
        header: 'Total potential income',
        isFixed: true,
    },
    {
        key: 'invisibleUnits',
        field: 'invisibleUnits',
        header: '',
        isHidden: true,
        isFixed: true,
    },
    {
        key: 'invisibleUnits',
        field: 'invisibleUnits',
        header: '',
        isHidden: true,
        isFixed: true,
    },
    {
        key: 'invisibleUnits',
        field: 'invisibleUnits',
        header: '',
        isHidden: true,
        isFixed: true,
    },
    {
        key: 'invisibleUnits',
        field: 'invisibleUnits',
        header: '',
        isHidden: true,
        isFixed: true,
    },
    {
        key: 'valuePerSfPerYear',
        field: 'valuePerSfPerYear',
        header: '$/RSF/year',
        isFixed: true,
    },
    {
        key: 'amountPerYear',
        field: 'amountPerYear',
        header: 'Amount/year',
        isFixed: true,
    },
];
